import "./CountertopUniversityForm.scss"
import { useNavigate, useParams } from "react-router-dom";
import IncompleteVideoIcon from '../../../../assets/images/Incomplete Video Icon.svg';
import CompletedItemIcon from '../../../../assets/images/Completed Item Icon.svg';
import IncompleteQuestionItemIcon from '../../../../assets/images/Incomplete Question Item Icon.svg';
import { showErrorMessage } from "../../../../utils/messages";
import { CountertopUniversityDetail } from "../types/CountertopUniversityDetail";
import { CountertopUniversityType } from "../types/CountertopUniversityType";
import { Button } from "devextreme-react";
import { useMemo } from "react";

export default function CountertopUniversityCard({ item, onGenerateCertificateClick, allItems } : { item: CountertopUniversityDetail, onGenerateCertificateClick?: (parentCountertopUniversityID: number) => void, allItems?: CountertopUniversityDetail[]}) {
    const navigate = useNavigate();
    const parameters = useParams();

    const childrenSummary = useMemo(() => {
        if (!allItems) return '';
        
        const counts = {
            courses: allItems.filter(x => x.parentCountertopUniversityID === item.countertopUniversityID && x.universityType === CountertopUniversityType.Course).length,
            chapters: allItems.filter(x => x.parentCountertopUniversityID === item.countertopUniversityID && x.universityType === CountertopUniversityType.Academy).length,
            videos: allItems.filter(x => x.parentCountertopUniversityID === item.countertopUniversityID && x.videoUrl).length,
            quizzes: allItems.filter(x => x.parentCountertopUniversityID === item.countertopUniversityID && x.hasQuiz).length,
            surveys: allItems.filter(x => x.parentCountertopUniversityID === item.countertopUniversityID && x.universityType === CountertopUniversityType.Survey).length,
        };
        
        const parts = [];
        if (counts.chapters > 0) parts.push(`${counts.chapters} chapter${counts.chapters > 1 ? 's' : ''}`);
        if (counts.courses > 0) parts.push(`${counts.courses} course${counts.courses > 1 ? 's' : ''}`);
        if (counts.videos > 0) parts.push(`${counts.videos} video${counts.videos > 1 ? 's' : ''}`);
        if (counts.surveys > 0) parts.push(`${counts.surveys} survey${counts.surveys > 1 ? 's' : ''}`);
        if (counts.quizzes > 0) parts.push(`${counts.quizzes} quiz${counts.quizzes > 1 ? 'zes' : ''}`);
        
        return parts.join(', ');
    }, [item.countertopUniversityID, allItems]);


    const getCardTitle = (item: CountertopUniversityDetail): string => {
        if (!item.allowTakeQuiz)
            return "It's not possible to start the survey until you watch all videos from this folder!";

        return "";
    }

    return (
        <>
            {(item.universityType !== CountertopUniversityType.Certification || (item.universityType === CountertopUniversityType.Certification && item.lastSurveyAttempt !== undefined)) && (
                <div
                    className={`dx-card countertop-university-card-wrap ${!item.allowTakeQuiz ? 'blocked' : ''}`}
                    title={getCardTitle(item)}
                    onClick={() => {
                        if (item.universityType === CountertopUniversityType.Survey && item.surveyDone && item.lastSurveyAttempt !== undefined) return;
                        if (item.universityType === CountertopUniversityType.Certification && !item.certificationDone) return;
                        if (item.surveyLink && !item.allowTakeQuiz) {
                            showErrorMessage("It's not possible to start the survey until you watch all videos from this folder!");
                            return;
                        }
                        else {
                            if (parameters['*'] === '') {
                                navigate('/countertop-university/' + item.countertopUniversityID);
                            } else {
                                navigate('/countertop-university/' + parameters['*'] + '/' + item.countertopUniversityID);
                            }
                        }
                    }}
                >
                    <img className="countertop-university-card-img" src={item.imageUrl || ''} />

                    <div className='title'>
                        <span className="countertop-university-card-title">{item.title}</span>
                        <div></div>
                        {item.descriptionTitle && <><span style={{ fontWeight: 'bold' }}>{item.descriptionTitle}</span>
                            <div></div>
                        </>}
                    </div>

                    <div className='description'>
                        <div className="contertop-university-card-desc-title-block">
                            <span className="countertop-university-card-description-title">{item.description}</span>
                                {(item.universityType === CountertopUniversityType.Certification && (!item.certificationDone && item.surveyDone)) ? (
                                    <Button
                                        icon="dx-icon dx-icon-verticalaligntop"
                                        text="Get Certificate"
                                        onClick={() => {
                                            onGenerateCertificateClick && onGenerateCertificateClick(item.parentCountertopUniversityID!);
                                        }} >
                                    </Button>
                                ) : (
                                    <></>
                                )}
                        </div>
                    </div>

                    <div className='countertop-university-card-bottom'>
                        {childrenSummary && !item.videoUrl && <div className="countertop-university-card-item-block">
                            <span className="countertop-university-card-children-summary">{childrenSummary}</span>
                        </div>}

                        {item.videoUrl && (item.videoUrl || item.hasQuiz || item.surveyLink) && <div className="countertop-university-card-item-block">
                            {item.videoUrl && <span className="countertop-university-card-item"><img className="countertop-university-card-item-img" src={item.videoDone ? CompletedItemIcon : IncompleteVideoIcon} alt="Icon" />&nbsp;&nbsp;&nbsp;Video Completion</span>}
                            {item.hasQuiz && <span className="countertop-university-card-item"><img className="countertop-university-card-item-img" src={item.quizDone ? CompletedItemIcon : IncompleteQuestionItemIcon} alt="Icon" />&nbsp;&nbsp;&nbsp;Quiz Completion</span>}
                             {item.lastSurveyAttempt && !item.surveyDone && (
                                 <span className="countertop-university-card-item"> 
                                    <img className="countertop-university-card-item-img" src={item.lastSurveyAttempt ? CompletedItemIcon : IncompleteQuestionItemIcon} alt="Icon" />
                                    &nbsp;&nbsp;&nbsp;Answ. at: &nbsp;<span style={{fontSize: '0.75em'}}>{item.lastSurveyAttempt ? new Date(item.lastSurveyAttempt).toLocaleString() : ''}</span>
                                </span>
                            )}
                            {item.surveyLink && item.surveyDone && <span className="countertop-university-card-item"><img className="countertop-university-card-item-img" src={item.surveyDone ? CompletedItemIcon : IncompleteQuestionItemIcon} alt="Icon" />&nbsp;&nbsp;&nbsp;Survey Completion</span>}
                        </div>}

                        {(item.universityType !== CountertopUniversityType.Survey && item.certificationDone) ? (
                            <>
                                <span className={`status completed`}>{'Completed'}</span>
                            </>
                        ) : (
                            <span className={`status ${item.status?.toLowerCase() || 'incomplete'}`}>{item.status || 'Incomplete'}</span>
                        )}

                    </div>
                </div>
            )}
        </>
    )
}